import React from 'react';
import Footer from './Footer';

// Header is rendered once at the App level, not here — it needs to stay
// mounted across route changes so the active-tab indicator can animate
// between pages instead of popping in fresh on every navigation.
export default function PageLayout({ containerClassName = '', mainClassName, meta, children }) {
  return (
    <div className={containerClassName}>
      {meta}
      <main className={mainClassName}>{children}</main>
      <Footer />
    </div>
  );
}
